import {Collapse} from 'react-collapse';
import React from 'react';
import classNames from 'classnames';

class FAQItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpened: true
    };
  }

  handleCollapse() {
    this.setState({
      isOpened: !this.state.isOpened
    });
  }

  render() {
    return (
      <div className="faq-item">
        <h2 className='faq-question'>
          <span className="title">{this.props.question}</span>
          <span className={classNames('collapse', {'up': this.state.isOpened, 'down': !this.state.isOpened})} onClick={this.handleCollapse.bind(this)}></span>
        </h2>
        <Collapse isOpened={this.state.isOpened}>
          <div className='faq-answer' dangerouslySetInnerHTML={{__html:this.props.answer}}></div>
        </Collapse>
      </div>
    );
  }
}

export default FAQItem;



// WEBPACK FOOTER //
// ./components/faq/FAQItem.jsx